import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ProductTypes } from 'src/app/model/product/product-type';
import { Project } from 'src/app/model/project/project';
import { ProjectDisplayObservableService } from 'src/app/services/project-display-observable.service';

@Component({
  selector: 'app-design-step-content',
  templateUrl: './design-step.component.html',
  styleUrls: ['./design-step.component.scss']
})
export class DesignStepComponent implements OnInit {
  @Input()
  project: Project;

  @Input()
  client: boolean = false;

  @Output()
  save = new EventEmitter();

  PRODUCT_TYPES = ProductTypes;

  constructor(
    private projectDisplayObservableService: ProjectDisplayObservableService
  ) {}

  ngOnInit(): void {}

  updateDesignAssets(index: number) {
    if (index === 0) {
      this.projectDisplayObservableService
        .getDesignAssetsChangedSubscribable()
        .next();
    }
  }
}
